import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base-components/base.component';
import { ModalSize } from '../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { AccountCreationContext, AccountCreationModalComponent } from './customer-account-creation-modal.component';
import { CustomerAccountService } from './service/customer-account.service';

@Component({
    selector: 'customer-account-summary',
    templateUrl: './customer-account-summary.html',
    outputs: ['accountClicked', 'accountCreated'],
    inputs: ['customerNumber', 'hideActions', 'displayWell']
})
export class CustomerAccountSummaryComponent extends BaseComponent {
    public customerNumber: number;
    public hideActions = false;
    public displayWell = true;
    public customerAccounts: any;
    public accountClicked: Subject<any>;
    public accountCreated: Subject<any>;
    public columnData: any[];

    constructor(
        public modalService: MvdModalService,
        private customerAccountService: CustomerAccountService
    ) {
        super();
        this.accountClicked = new Subject<any>();
        this.accountCreated = new Subject<any>();
    }

    async ngOnInit() {
        this.UseHelpContent('#CONTENT/AZ_MVD_Now/Customer_Accounts.htm%3FTocPath%3DAZ%2520MVD%2520Now%7C_____4');

        var managedAccounts = (await this.customerAccountService.getCustomerAccounts(this.customerNumber).pipe(first()).toPromise()).result;
        var nonManagedAccounts = (await this.customerAccountService.getNonCustomerManagedAccounts(this.customerNumber).pipe(first()).toPromise()).result;

        this.customerAccounts = managedAccounts.concat(nonManagedAccounts);

        this.columnData = [
            { field: 'customerAccountNumberId', header: 'Account' },
            { field: 'accountStatus', header: 'Status' },
            { field: 'accountType', header: 'Account Type' },
            { field: 'accountBalance', header: 'Account Balance' }
        ];

        if (!this.hideActions) {
            this.columnData.push({ field: '', header: 'View' });
        }
    }

    handleAccountClick(customerAccountNumberId) {
        this.accountClicked.next(customerAccountNumberId);
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }

    popupAccountCreationModal() {
        const data = new AccountCreationContext(this.customerNumber);
        this.modalService.open(AccountCreationModalComponent, data, ModalSize.Medium).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(
                result => {
                    setTimeout(() => {
                        this.accountCreated.next(result.customerAccountNumberId);
                    }, 500);
                }
            );
    }
}
